export function pwOnBootComplete(): void {
    const callback = window.pwOnBootComplete;
    
    if (typeof callback === "function") {
        callback();
    }
}
